(() => {
  const CAROUSEL_ID_PREFIX = 'cd-editorial-carousel-track';
  let carouselCounter = 0;

  const arrowSvg = (direction) => {
    const path = direction === 'previous' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${path}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  };

  const makeArrow = (direction, trackId) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `cd-editorial-carousel__arrow cd-editorial-carousel__arrow--${direction}`;
    button.setAttribute('aria-label', direction === 'previous' ? 'Previous items' : 'Next items');
    button.setAttribute('aria-controls', trackId);
    button.innerHTML = arrowSvg(direction);
    return button;
  };

  const enhanceCarousel = (track, kind) => {
    if (!track || track.closest('.cd-editorial-carousel')) return;

    const itemCount = track.children.length;
    if (itemCount < 2) return;

    const shell = document.createElement('div');
    shell.className = `cd-editorial-carousel cd-editorial-carousel--${kind}`;
    track.parentNode.insertBefore(shell, track);
    shell.appendChild(track);

    if (!track.id) {
      carouselCounter += 1;
      track.id = `${CAROUSEL_ID_PREFIX}-${carouselCounter}`;
    }
    track.setAttribute('data-cd-carousel-track', '');

    const previous = makeArrow('previous', track.id);
    const next = makeArrow('next', track.id);
    shell.insertBefore(previous, track);
    shell.appendChild(next);

    const getStep = () => {
      const firstItem = track.firstElementChild;
      if (!firstItem) return track.clientWidth * 0.9;
      const styles = window.getComputedStyle(track);
      const parsedGap = parseFloat(styles.columnGap || styles.gap || '0');
      const gap = Number.isFinite(parsedGap) ? parsedGap : 0;
      return firstItem.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const hasOverflow = maxScroll > 3;
      shell.classList.toggle('cd-editorial-carousel--static', !hasOverflow);
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;

      if (!hasOverflow) return;
      const atStart = track.scrollLeft <= 3;
      const atEnd = track.scrollLeft >= maxScroll - 3;
      previous.disabled = atStart;
      next.disabled = atEnd;
    };

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    requestAnimationFrame(update);
  };

  const addMaterialsDivider = () => {
    const discovery = document.querySelector('.cd-materials-page .cd-materials-discovery');
    if (!discovery) return;
    if (discovery.previousElementSibling && discovery.previousElementSibling.classList.contains('cd-editorial-section-divider')) return;

    const divider = document.createElement('div');
    divider.className = 'cd-editorial-section-divider';
    divider.setAttribute('aria-hidden', 'true');
    discovery.before(divider);
  };

  const init = () => {
    addMaterialsDivider();
    document.querySelectorAll('.cd-material-covers').forEach((track) => enhanceCarousel(track, 'materials'));
    document.querySelectorAll('.cd-story__gallery').forEach((track) => enhanceCarousel(track, 'gallery'));
    document.querySelectorAll('.cd-material-products__grid').forEach((track) => enhanceCarousel(track, 'products'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
